import { render, staticRenderFns } from "./ImageDetailsDrawer.vue?vue&type=template&id=d38cc5c0&scoped=true"
import script from "./ImageDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./ImageDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./ImageDetailsDrawer.vue?vue&type=style&index=0&id=d38cc5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38cc5c0",
  null
  
)

export default component.exports